import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFileType } from "@/shared/utils/filePreviewUtilities";
import useProjectStore from "@/shared/zustand/projectManagementStore";
import useToastStore from "@/shared/zustand/toastStore";
import { FileText, History, Pencil, Plus, FileJson, FileMusic, FileType, File, FileImage, FileVideo2, Download, Loader, Trash, } from "lucide-react";
import { Button } from "primereact/button";
import { SquareArrowOutUpRight } from "lucide-react";
import React, { useState } from "react";
import { MF_EVENTS, } from "@/shared/microfrontend/interfaces/microFrontend";
import { useHostMicroFrontendApi } from "@/shared/microfrontend/hooks/useHostMicroFrontend";
import { isArtifactDataFilename, isProjectFilePath, } from "@/shared/utils/helpers";
import { downloadFileFromGCS, getFileContent } from "@/core/api/api";
import { Tooltip } from "primereact/tooltip";
import { service_account_raw } from "@/constants";
const CustomTimeline = ({ files, addingFiles, setAddingFiles, setFileDialogVisible, userHasAccessToProject, setDeleteFileDialogVisible }) => {
    const { setPreviewDialogVisible, setSelectedFile, setDialogVisible } = useProjectStore();
    // State to track which files are currently downloading
    const [downloadingFiles, setDownloadingFiles] = useState([]);
    const addDownloadingFile = (fileUrl) => {
        setDownloadingFiles((prev) => [...prev, fileUrl]);
    };
    const removeDownloadingFile = (fileUrl) => {
        setDownloadingFiles((prev) => prev.filter((url) => url !== fileUrl));
    };
    return (_jsxs("div", { className: "custom-timeline relative h-fit max-h-full", children: [_jsx("div", { className: "relative flex justify-center mb-6", children: _jsxs(Button, { title: !userHasAccessToProject ? "Dont have access to add files" : "Add files in this Project", disabled: !userHasAccessToProject || addingFiles, 
                    // className="px-3 py-1 text-xs text-[#fff] flex items-center justify-center gap-x-2 rounded-full bg-[#5928ed] cursor-pointer"
                    className: !userHasAccessToProject ? " pointer-events-auto cursor-not-allowed flex-shrink-0 px-3 py-1 text-xs text-[#fff] flex items-center justify-center gap-x-2 rounded-full bg-[#5928ed]" : " flex-shrink-0 px-3 py-1 text-xs text-[#fff] flex items-center justify-center gap-x-2 rounded-full bg-[#5928ed] cursor-pointer", style: { zIndex: 10 }, onClick: () => {
                        setAddingFiles(true);
                        setFileDialogVisible(true);
                    }, children: [_jsx(Plus, { size: 16, color: "white" }), _jsx("span", { children: "Add files" })] }) }), files?.map((file, index) => (_jsx(TimelineItem, { item: file, isUserUploaded: !file?.isAI, isHistory: file?.isHistory, setPreviewDialogVisible: setPreviewDialogVisible, setSelectedFile: setSelectedFile, setDialogVisible: setDialogVisible, isDownloading: downloadingFiles.includes(file.url), addDownloadingFile: addDownloadingFile, removeDownloadingFile: removeDownloadingFile, userHasAccessToProject: userHasAccessToProject, setDeleteFileDialogVisible: setDeleteFileDialogVisible }, index)))] }));
};
const renderFileIcon = (fileExtension, color) => {
    if (!fileExtension)
        return _jsx(File, { size: 24, color: color });
    const fileType = getFileType(fileExtension);
    if (fileExtension === "txt")
        return _jsx(FileType, { size: 24, color: color });
    else if (fileExtension === "docx" || fileExtension === "pdf")
        return _jsx(FileText, { size: 24, color: color });
    else if (fileExtension === "json")
        return _jsx(FileJson, { size: 24, color: color });
    else if (fileType === "audio")
        return _jsx(FileMusic, { size: 24, color: color });
    else if (fileType === "image")
        return _jsx(FileImage, { size: 24, color: color });
    else if (fileType === "video")
        return _jsx(FileVideo2, { size: 24, color: color });
    return _jsx(File, { size: 24, color: color });
};
const TimelineItem = ({ item, isUserUploaded, isHistory, setPreviewDialogVisible, setSelectedFile, setDialogVisible, isDownloading, addDownloadingFile, removeDownloadingFile, userHasAccessToProject, setDeleteFileDialogVisible, }) => {
    const mfApi = useHostMicroFrontendApi();
    const showToast = useToastStore((state) => state.showToast);
    const handleCardClick = (e) => {
        const target = e.target;
        const isEditIconClick = target.closest(".edit-icon");
        if (!isEditIconClick) {
            if (!isHistory) {
                setPreviewDialogVisible(true);
                setSelectedFile(item);
            }
            else {
                window.open(item.url, "_blank");
            }
        }
    };
    const getArtifactData = async (item) => {
        try {
            if (item.url && isProjectFilePath(item.url)) {
                showToast("info", "Info", "Artifact Preview Loading...");
                const formData = new URLSearchParams();
                formData.append("file_path", item.url);
                // old code for api call
                // const response = await axios.post(
                //   `${process.env.VITE_BASE_API_URL}/gcs/get-file-content`,
                //   formData,
                //   {
                //     headers: {
                //       accept: "application/json",
                //       "Content-Type": "application/x-www-form-urlencoded",
                //     },
                //   }
                // );
                const { responseData, error } = await getFileContent(item.url);
                if (error) {
                    showToast("error", "Error", error.errorMessage);
                    return;
                }
                if (!responseData || !responseData.content) {
                    showToast("error", "Error", "Error in extracting the artifact data");
                    return;
                }
                // const data: { content: string } = response.data;
                const parsedJSONData = JSON.parse(responseData?.content);
                // console.log("parsedJSONData", parsedJSONData);
                if (!mfApi) {
                    showToast("error", "Error", "MF API not found");
                    return;
                }
                mfApi.dispatch(MF_EVENTS.SHOW_ARTIFACT_DATA, parsedJSONData);
            }
        }
        catch (error) {
            console.error("Error in extracting the artifact data", error);
            showToast("error", "Error", "Error in extracting the artifact data");
            return;
        }
    };
    const downLoadFile = async (item) => {
        try {
            addDownloadingFile(item.url);
            const { responseData, error } = await downloadFileFromGCS(item.url, service_account_raw);
            // removing irrespective of outcome
            removeDownloadingFile(item.url);
            if (error) {
                showToast("error", "Error", error.errorMessage);
                console.log("Error in downloading the file", error);
                return;
            }
            // console.log("Printing the response data", responseData);
            if (responseData) {
                if (!(responseData instanceof Blob)) {
                    console.error("Response data is not a Blob:", responseData);
                    showToast("error", "Error", "Invalid file data received");
                    return;
                }
                // Create a URL for the Blob
                const url = window.URL.createObjectURL(responseData);
                // Create a temporary link element
                const link = document.createElement("a");
                link.href = url;
                // Extract filename from item.url
                const urlParts = item.url.split('/');
                const filename = urlParts[urlParts.length - 1];
                // Set the download attribute with the filename
                link.setAttribute("download", filename);
                // Append link to the DOM, trigger click, and clean up
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                // Revoke the object URL to free memory
                window.URL.revokeObjectURL(url);
            }
        }
        catch (error) {
            removeDownloadingFile(item.url);
            showToast("error", "Error", "Failed to download file");
            console.error("Download error:", error);
        }
    };
    return (_jsxs("div", { className: `timeline-item flex items-center my-4 ${isUserUploaded ? "flex-row" : "flex-row-reverse"}`, children: [_jsx("div", { className: "timeline-connector absolute left-1/2 transform -translate-x-1/2 w-0.5 bg-[#E5E7EB] h-full" }), _jsx("div", { className: `
        timeline-marker 
        absolute 
        left-1/2 
        transform 
        -translate-x-1/2 
        w-4 
        h-4 
        rounded-full 
        ${isHistory
                    ? "bg-[#0D9488]"
                    : item.isEditable
                        ? "bg-[#5928ED]"
                        : "bg-[#bfbfbf]"}
      `, style: { zIndex: 1 } }), _jsx("div", { className: `
        timeline-content 
        w-[45%] 
        p-4 
        border 
        rounded-[8px] 
        ${isUserUploaded ? "mr-auto " : "ml-auto "}
cursor-pointer
        ${isHistory
                    ? "bg-[#0D9488]/5 border-[#0D9488]/20 "
                    : item.isEditable
                        ? "bg-[#5928ED]/5 border-[#5928ED]/20 "
                        : "bg-[#fff] border-[#BFBFBF] "}
      `, onClick: (e) => isArtifactDataFilename(item.name)
                    ? getArtifactData(item)
                    : handleCardClick(e), children: _jsx("div", { className: "flex flex-col items-start justify-between gap-y-2", children: _jsxs("div", { className: "w-full flex justify-between items-center overflow-hidden", children: [_jsxs("div", { className: "w-full flex items-center gap-3 overflow-hidden", children: [_jsx("div", { className: `
              w-12 h-12 
              rounded-[6px] 
              flex items-center 
              justify-center
              border 
              flex-shrink-0
              ${isHistory
                                            ? "bg-[#0D9488]/10 border-[#0D9488]/10"
                                            : item.isEditable
                                                ? "bg-[#5928ED]/10 border-[#5928ED]/10"
                                                : "bg-[#fff] border-[#bfbfbf]/50"}
              cursor-pointer
            `, children: isHistory ? (_jsx(History, { size: 24, color: "#0D9488" })) : (renderFileIcon(item.name.split(".").pop() ?? "", !item.isEditable ? "#bfbfbf" : "#5928ED")) }), _jsxs("div", { className: "flex flex-col gap-y-1 min-w-0 overflow-hidden", children: [_jsx(Tooltip, { target: ".file-title", position: "top" }), _jsx("span", { className: "file-title font-medium", "data-pr-tooltip": isArtifactDataFilename(item.name) ? item.name.replace(".json", "") : item.name, children: isArtifactDataFilename(item.name)
                                                    ? item.name.replace(".json", "").length > 25
                                                        ? `${item.name.replace(".json", "").slice(0, 25)}...` +
                                                            item.name.replace(".json", "").split(".").pop()
                                                        : item.name.replace(".json", "")
                                                    : item?.name?.length > 25
                                                        ? `${item?.name?.slice(0, 25)}...` +
                                                            item.name.split(".").pop()
                                                        : item?.name }), _jsx("span", { className: "text-sm text-gray-500", children: new Date(item?.timestamp)?.toLocaleDateString() })] })] }), _jsx("div", { children: !isHistory &&
                                    (item?.isEditable && !isArtifactDataFilename(item.name) ? (_jsxs("div", { className: "flex gap-x-1", children: [_jsx(Button, { title: isDownloading ? "Downloading..." : "Download file", icon: isDownloading ? _jsx(Loader, { size: 16, className: "animate-spin" }) : _jsx(Download, { size: 16 }), 
                                                // className="ml-auto p-button-text p-button-rounded"
                                                className: !userHasAccessToProject ? " pointer-events-auto opacity-50 cursor-not-allowed flex-shrink-0 ml-auto p-button-text p-button-rounded" : " flex-shrink-0 ml-auto p-button-text p-button-rounded", disabled: !userHasAccessToProject || isDownloading, onClick: (e) => {
                                                    e.stopPropagation(); // Prevent parent card click
                                                    if (!isDownloading) {
                                                        downLoadFile(item);
                                                    }
                                                } }), _jsx(Button, { title: "Delete file", icon: _jsx(Trash, { size: 16 }), disabled: !userHasAccessToProject, className: !userHasAccessToProject ? " pointer-events-auto opacity-50 cursor-not-allowed flex-shrink-0 ml-auto p-button-text p-button-rounded" : " flex-shrink-0 ml-auto p-button-text p-button-rounded text-red-500", onClick: (e) => {
                                                    e.stopPropagation(); // Prevent parent card click
                                                    setSelectedFile(item);
                                                    setDeleteFileDialogVisible(true);
                                                } }), _jsx(Button, { title: "Edit file title", icon: _jsx(Pencil, { size: 16 }), disabled: !userHasAccessToProject, 
                                                // className="edit-icon ml-auto p-button-text p-button-rounded"
                                                className: !userHasAccessToProject ? " pointer-events-auto opacity-50 cursor-not-allowed flex-shrink-0 edit-icon ml-auto p-button-text p-button-rounded" : " flex-shrink-0 edit-icon ml-auto p-button-text p-button-rounded", onClick: () => {
                                                    setSelectedFile(item);
                                                    setDialogVisible(true);
                                                } })] })) : isArtifactDataFilename(item.name) ? (_jsxs("div", { className: "flex gap-x-1", children: [_jsx(Button, { title: "Delete file", icon: _jsx(Trash, { size: 16 }), disabled: !userHasAccessToProject, className: !userHasAccessToProject ? " pointer-events-auto opacity-50 cursor-not-allowed flex-shrink-0 ml-auto p-button-text p-button-rounded" : " flex-shrink-0 ml-auto p-button-text p-button-rounded text-red-500", onClick: (e) => {
                                                    e.stopPropagation(); // Prevent parent card click
                                                    setSelectedFile(item);
                                                    setDeleteFileDialogVisible(true);
                                                } }), _jsx(Button, { title: "View artifact data", icon: _jsx(SquareArrowOutUpRight, { size: 16 }), className: "edit-icon ml-auto p-button-text p-button-rounded", onClick: (e) => {
                                                    e.stopPropagation(); // Prevent parent card click
                                                    getArtifactData(item);
                                                } })] })) : null) })] }) }) })] }));
};
export default CustomTimeline;
